import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2ParentIcon = ({
  color = "currentColor",
  strokeWidth = 1,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 21 21.08",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 21.08),
    children: [/*#__PURE__*/jsx("path", {
      d: "m14.23 4.64a3.76 3.76 0 1 1 -3.37-4.12 3.76 3.76 0 0 1 3.37 4.12z"
    }), /*#__PURE__*/jsx("path", {
      d: "m17.48 9.43a2.6 2.6 0 1 1 -2.33-2.85 2.6 2.6 0 0 1 2.33 2.85z"
    }), /*#__PURE__*/jsx("path", {
      d: "m.5 17.41v-4.01a5 5 0 0 1 5-5h2.8a5 5 0 0 1 5.01 5v7.2"
    }), /*#__PURE__*/jsx("path", {
      d: "m11.3 20.44v-5.1a3.49 3.49 0 0 1 3.6-3.37h2a3.49 3.49 0 0 1 3.6 3.37v2.47"
    })]
  });
};

export { PM2ParentIcon };
//# sourceMappingURL=parent.js.map
